import React, { useEffect, useState, useContext } from 'react'
import MapContext from './MapContext'

import PlusIcon from '../../icons/plus.svg'
import MinusIcon from '../../icons/minus.svg'

const NavigationControl = (props) => {
  const map = useContext(MapContext)
  const [state, setState] = useState()

  useEffect(() => {
    if (!map) return

    const mapChangeHandler = () => {
      if (map.getZoom() === map.getMinZoom()){
        setState('minzoom')
      } else if (map.getZoom() === map.getMaxZoom()){
        setState('maxzoom')
      } else {
        setState(null)
      }
    }

    map.on('zoomend', mapChangeHandler)
    mapChangeHandler()

    return () => {
      if (map && map.off) {
        map.off('zoomend', mapChangeHandler)
      }
    }
  }, [map])

  return (
    <>
      {(state === 'maxzoom') && (
        <button className="button basic circular fa disabled">
          <PlusIcon/>
        </button>
      )}
      {(state !== 'maxzoom') && (
        <button className="button secondary circular fa"
          onClick={(e) => map.zoomIn(null, {originalEvent: e})}>
          <PlusIcon/>
        </button>
      )}
      {(state === 'minzoom') && (
        <button className="button basic circular fa disabled">
          <MinusIcon/>
        </button>
      )}
      {(state !== 'minzoom') && (
        <button className="button secondary circular fa"
          onClick={(e) => map.zoomOut(null, {originalEvent: e})}>
          <MinusIcon/>
        </button>
      )}
    </>
  )
}

export default NavigationControl
